import { TrashIcon } from '../../../../../assets/icons/TrashIcon';
import searchImageNotFound from '../../../../../assets/Vector.png';

type dataListType = {
  id: string;
  nome: string;
  tipo: string;
};

type NoOrderedListProps = {
  title: string;
  dataList: dataListType[];
  handleDataList: (data: dataListType) => void;
};

export const NoOrderedList = ({
  title,
  dataList,
  handleDataList
}: NoOrderedListProps) => {
  return (
    <div
      className={`${
        dataList.length === 0 ? 'tw-hidden' : 'tw-block'
      } tw-p-[1.88rem]`}
    >
      <div className="tw-flex tw-justify-between tw-items-center">
        <h1 className="tw-text-[1.25rem] tw-text-[#323232] tw-leading-[2rem] tw-font-bold">
          {title}
        </h1>
        <p className="tw-text-[1rem] tw-text-[#001E64] tw-leading-[1.5rem]">
          Qtd de usuário:&nbsp;<strong>{dataList.length}</strong>
        </p>
      </div>
      <ul className="tw-flex tw-flex-col tw-gap-[0.63rem] tw-py-[1.25rem]">
        {dataList.map((data, index) => {
          return (
            <li
              key={index}
              className={`${
                index % 2 !== 0 ? 'tw-bg-[#E8EEF5]' : 'tw-bg-[#F4F4F4]'
              } tw-border-l-[0.31rem] tw-border-l-[#FF5000] tw-w-full tw-flex tw-items-center tw-justify-between tw-py-[1rem] tw-px-[2.19rem] tw-rounded-[0.28rem]`}
            >
              <span className="tw-text-[0.875rem] tw-text-[#001E64] tw-leading-[1.5rem] tw-w-[15%]">
                {data.nome}
              </span>
              {/* <span
                className={`${
                  data.tipo === 'autonomo'
                    ? 'tw-bg-[#001E64]'
                    : 'tw-bg-[#FF5000]'
                } tw-p-[0.44rem] mb:tw-hidden sm:tw-inline tw-text-[0.875rem] tw-text-white tw-leading-[1.5rem] tw-rounded-[0.47rem]`}
              >
                {data.tipo === 'autonomo'
                  ? 'Autônomo'
                  : data.tipo.toUpperCase()}
              </span> */}
              <button
                className="tw-cursor-pointer"
                onClick={() => {
                  handleDataList(data);
                }}
              >
                <TrashIcon w="1.5rem" h="1.5rem" />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
